import { render, staticRenderFns } from "./ImprimirProcesada.vue?vue&type=template&id=afaacd18"
import script from "./ImprimirProcesada.vue?vue&type=script&lang=js"
export * from "./ImprimirProcesada.vue?vue&type=script&lang=js"
import style1 from "./ImprimirProcesada.vue?vue&type=style&index=1&id=afaacd18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports